var exports = {
  "k": "x93eb46d8--d894f0--container",
};

module.exports = exports;
